export default "__VITE_ASSET__BC83qDw1__"